export default __webpack_public_path__ + "src/assets/img_frame_313752.1d43b4f3394127e8af1c075095bcdd77.webp";